<template>
  <div class="create-team">
    <el-form
      v-loading="loading"
      :model="workRateForm"
      ref="workRateForm"
      class="white-bg form"
      label-position="left"
      label-width="160px"
      disabled
    >
      <div class="flex flex-v-center flex-h-bet">
        <h2 class="text-gray bold mt-0 mb-40">
          {{ workRateForm.group_name && workRateForm.group_name }}
        </h2>
        <div class="btn-wrapper mb-10 mr-20 move-right">
          <router-link
            to="/admin/attendance/overtime/settings/work-rate"
            class="btn-back"
          >
            <span>Back</span>
          </router-link>
        </div>
      </div>

      <div class="mt-20 border">
        <el-form-item
          prop="monthly_salary"
          label="Monthly Salary"
          v-if="workRateForm.use_custom_charge"
        >
          <el-input
            placeholder="Enter value"
            v-model="workRateForm.monthly_salary"
          ></el-input>
        </el-form-item>
      </div>

      <el-form-item
        prop="payroll_charges"
        label="Monthly Salary"
        class="mt-30"
        v-if="!workRateForm.use_custom_charge"
      >
        <el-select
          v-model="workRateForm.payroll_charges"
          class="inline-select"
          multiple
        >
          <el-option
            v-for="item in workRateForm.pay_breakdowns"
            :key="item.id"
            :label="item.allowance_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <h4
        class="text-gray bold mt-20 mb-40"
        v-if="workRateForm.monthly_workdays.length"
      >
        Set Monthly Workdays
      </h4>
      <div v-for="item in workRateForm.monthly_workdays" :key="item.id">
        <el-form-item :label="item.name" prop="days" class="mt-20">
          <el-input v-model="item.days" class="inline-input"></el-input>
          <span class="ml-10 bold">Days</span>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/attendance/overtime");
import { capitalize } from "@/helpers/functions";

export default {
  data() {
    return {
      loading: false,
      workRateForm: {
        group_name: "",
        payroll_charges: [],
        monthly_salary: null,
        monthly_workdays: [
          {
            name: "January",
            month_id: 1,
          },
          {
            name: "February",
            month_id: 2,
          },
          {
            name: "March",
            month_id: 3,
          },
          {
            name: "April",
            month_id: 4,
          },
          {
            name: "May",
            month_id: 5,
          },
          {
            name: "June",
            month_id: 6,
          },
          {
            name: "July",
            month_id: 7,
          },
          {
            name: "August",
            month_id: 8,
          },
          {
            name: "September",
            month_id: 9,
          },
          {
            name: "October",
            month_id: 10,
          },
          {
            name: "November",
            month_id: 11,
          },
          {
            name: "December",
            month_id: 12,
          },
        ],
      },
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.fetchWorkRate(id);
    }
  },
  methods: {
    capitalize,
    ...mapActions(["getWorkRateById"]),
    fetchWorkRate(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/attendance/overtime/getWorkRateById", id)
        .then(response => {
          this.loading = false;
          const {
            group_name,
            custom_charge,
            workrateables,
            pay_breakdowns,
            use_custom_charge,
          } = response.data;
          const newDays = [];
          workrateables.map(workrate => {
            const found = this.workRateForm.monthly_workdays.find((x, i) =>
              x.month_id === workrate.month_id
                ? {
                    id: i,
                    name: x.name,
                    month_id: workrate.month_id,
                  }
                : ""
            );
            const d = found ? { ...found, days: workrate.days } : "";
            newDays.push(d);
          });

          this.workRateForm = {
            ...this.workRateForm,
            group_name,
            monthly_salary: custom_charge,
            monthly_workdays: newDays,
            use_custom_charge: Boolean(use_custom_charge),
            pay_breakdowns: use_custom_charge ? [] : pay_breakdowns,
            payroll_charges: pay_breakdowns.map(pb => {
              return pb.id;
            }),
          };
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.month.el-input-number .el-input-number__decrease,
.month.el-input-number .el-input-number__increase {
  background-color: #ffffff !important;
  color: #888888 !important;
}

.el-input-number__decrease {
  background-color: #ffffff !important;
}

.el-input.inline-input {
  width: 10% !important;
}
</style>
